module.exports = __webpack_public_path__ + "static/media/user-number.44793d67.svg";